<template>
  <v-container fluid>
    <v-layout align-center justify-center column fill-height>
      <span class='title'>ACCESS DENIED</span>
      <span>You do not have access to this page.</span>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'AccessDenied',
    data () {
      return {
      }
    }
  }
</script>

<style>
</style>
